import { stylishMetricResult, suffixNumberDisplay } from 'modules/experiments/utils';
import {
  AudienceBreakdownTooltipRow,
  TooltipMetrics,
  TooltipVariantCircle,
  TooltipVariantLetter,
} from './Styled';

type AudienceTooltipRowProps = {
  variantPercent: number;
  sends: number;
  alphabet: string;
  backgroundColor: string;
  borderColor: string;
  index: number;
  hasSendSize: boolean;
};

export const AudienceTooltipRow = ({
  variantPercent,
  sends,
  alphabet,
  backgroundColor,
  borderColor,
  hasSendSize,
  index,
}: AudienceTooltipRowProps) => {
  return (
    <AudienceBreakdownTooltipRow first={index === 0}>
      <TooltipMetrics>
        <TooltipVariantCircle backgroundColor={backgroundColor} borderColor={borderColor} />
        <TooltipVariantLetter>{alphabet}</TooltipVariantLetter>
      </TooltipMetrics>
      <TooltipMetrics>
        <div>{stylishMetricResult(variantPercent / 100, 'percentage')}</div>
        {hasSendSize && <div>&nbsp;~{suffixNumberDisplay(sends)}</div>}
      </TooltipMetrics>
    </AudienceBreakdownTooltipRow>
  );
};
